import { CustomerCreateSchema } from '@ca/common'
import type { z } from 'zod'
import type { CreateCustomerData } from '../schemas'
import { getRegionCountryCode } from './helpers'
import { hasAnyInvoiceData } from './invoice'
import { isKidsAccount } from './isKids'

type CustomerCreateInput = z.infer<typeof CustomerCreateSchema>

export const buildCustomerCreatePayload = (
  data: Partial<CreateCustomerData>,
  regionCountryCode?: string
): CustomerCreateInput | null => {
  const {
    birthday,
    policies: _policies,
    parentData: _parent,
    parentAuthStatus: _parentAuthStatus,
    invoice,
    ...rest
  } = data
  const kids = isKidsAccount(data)

  const address = kids
    ? {
        street: invoice?.street ?? null,
        street2: invoice?.street2 ?? null,
        city: invoice?.city ?? null,
        zip: invoice?.zip ?? null,
        country_code: getRegionCountryCode(
          invoice?.country_code,
          regionCountryCode || 'DE'
        ),
      }
    : rest.address

  const parsed = CustomerCreateSchema.safeParse({
    title: null,
    birth_date: birthday?.toISOString(),
    ...rest,
    address,
    email: rest.email || null,
    mobile: rest.mobile || null,
    invoice: kids || hasAnyInvoiceData(invoice) ? invoice : undefined,
    is_kids: kids,
  })

  if (!parsed.success) {
    return null
  }

  return parsed.data
}
